import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService, platformLangFactory, TitanModule } from '@recriar/titan';
import {
  provideMihmoAuthEnvironment,
  QUICK_LOGIN_SOURCE,
  QuickLogin,
} from '@recriar/mihmo-auth';
import { PAGE_ATTENDANCE_STATE, PAGE_HOST_WIDGETS } from '@recriar/niemeyer';
import { environment } from '../../environments/environment';
import { AttendanceCommonService } from '../features/attendance/services/attendance-common/attendance-common.service';
import { ChatIconContainerComponent } from '../features/chat/containers/chat-container-one-selected-customer/chat-icon-container.component';
import { CustomerHeaderBadgesComponent } from '../features/shared/components/customer-header-badges/customer-header-badges.component';
import { CustomerAssignmentBadgesComponent } from '../features/shared/components/customer-assignment-badges/customer-assignment-badges.component';

@NgModule({
  imports: [
    CommonModule,
    TitanModule.forRoot({
      apiBaseUrl: environment.api,
      appStoragePrefix: 'mihmo-admin',
      platformLangFactory: platformLangFactory,
      disableCultureInterceptor: true,
      disableRetryPolicy: true,
    }),
  ],
  providers: [
    // A lib de auth não pode importar `environment` (criaria a circular
    // admin -> mihmo-auth -> admin). O app injeta os valores aqui, num módulo
    // EAGER: AuthService/UserService são providedIn:'root' e usados por guards
    // que rodam antes do chunk lazy do MihmoAuthModule.
    ...provideMihmoAuthEnvironment({
      apiNestUrl: environment.apiNest,
      firebaseApiKey:
        environment.production === 'true'
          ? environment.firebaseAuthConfigProd.apiKey
          : environment.firebaseAuthConfigDev.apiKey,
    }),

    // O `ni-page-default` (niemeyer) renderiza estes componentes de feature no
    // cabeçalho. A lib declara só o contrato em page-host.tokens.ts; quem liga
    // as implementações é o app, aqui — do contrário a lib de UI conheceria
    // regras de negócio do produto (circular admin -> niemeyer -> admin).
    {
      provide: PAGE_HOST_WIDGETS,
      useValue: {
        chatIcon: ChatIconContainerComponent,
        customerBadges: CustomerHeaderBadgesComponent,
        assignmentBadges: CustomerAssignmentBadgesComponent,
      },
    },
    {
      provide: PAGE_ATTENDANCE_STATE,
      useExisting: AttendanceCommonService,
    },
    // Login rápido só em localhost. O JSON vem de apps/admin/dev-only (fora do
    // git) e só é copiado nos builds dev/hom — ver project.json.
    {
      provide: QUICK_LOGIN_SOURCE,
      useFactory: (http: HttpService) =>
        environment.production === 'true' ||
        !['localhost', '127.0.0.1'].includes(window.location.hostname)
          ? null
          : () =>
              http
                .disableApiPrefix()
                .disableAuthentication()
                .disableErrorHandling()
                .disableRetryPolicy()
                .disableCulture()
                .get<QuickLogin[]>('/assets/dev/quick-logins.local.json')
                .pipe(catchError(() => of([] as QuickLogin[]))),
      deps: [HttpService],
    },
  ],
})
export class CoreModule {}
